import { render } from "./UserEditHardDelete.vue?vue&type=template&id=6b413c4f&scoped=true"
import script from "./UserEditHardDelete.vue?vue&type=script&lang=js"
export * from "./UserEditHardDelete.vue?vue&type=script&lang=js"

import "./UserEditHardDelete.vue?vue&type=style&index=0&id=6b413c4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b413c4f"]])

export default __exports__